import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private _adminApi = `${environment.administration}/organizations`;
  private passwordUrl = `${environment.common}`;
  private passwordUrlFromEmail = `${environment.integration}`;

  constructor(
    private _http: HttpClient
  ) { }


  // add organization service 
  addOrganization(formData: any) {
    return this._http.post<any>(`${this._adminApi}/addorganization`, formData);
  }
  // add organization contact 
  addOrganizationContact(formData: any) {
    return this._http.post<any>(`${this._adminApi}/addcontact`, formData);
  }

  // add organization brand
  addOrganizationBrand(formData: any) {
    return this._http.post<any>(`${this._adminApi}/addbrand`, formData);
  }

  // get  all organizations 
  getOrganizations(pageNo: any, pageSize: any, searchKeyword: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    };
    return this._http.post<any>(`${this._adminApi}`, paginationSettings);
  }

  // get organization
  getOrganization(id: any): Observable<any> {
    return this._http.get<any>(`${this._adminApi}/organization/${id}`)
  }

  //  delete organization

  deleteOrganization(id: any) {
    return this._http.delete<any>(`${this._adminApi}/organization/${id}`)
  }

  // upload user image
  uploadOrganizationLogo(formData: any, organizationId: any) {
    return this._http.post<any>(`${environment.administration}/organization/uploadimage/${organizationId}`, formData);
  }

  // upload user image
  uploadAddUserImage(formData: any) {
    return this._http.post<any>(`${environment.administration}/user/uploadimage`, formData);
  }

  // Update add organization

  updateOrganizationDetails(id: any, formDate: any) {
    return this._http.put<any>(`${this._adminApi}/organization/${id}`, formDate)
  }

  // change passowrd 
  changePassword(id: any, entityType: any, password: any) {
    const jsonData = { id, entityType, password }; // Create the JSON object
    return this._http.put<any>(`${this.passwordUrl}/changepassword`, jsonData);
  }


  // change passowrd 
  changePasswordFromEmail(id: any, cid: any, entityType: any, password: any) {
    const jsonData = { id, cid, entityType, password }; // Create the JSON object
    return this._http.post<any>(`${this.passwordUrlFromEmail}/changepasswordfromemail`, jsonData);
  }
  validatePassword(id: any, entityType: any, password: any) {
    const jsonData = { id, entityType, password }; // Create the JSON object
    return this._http.put<any>(`${this.passwordUrl}/passwordvalidation`, jsonData);
  }

  // get all notifications
  getNotifications(notificationId: string): Observable<any> {
    return this._http.get<any>(`${environment.administration}/usernotifications/${notificationId}`)
  }

  updateNotifications(targetId: any): Observable<any> {
    return this._http.put<any>(`${environment.administration}/updateNotifications/${targetId}`, {});
  }

  updateNotificationById(pushNotificationId: any): Observable<any> {
    return this._http.put<any>(`${environment.administration}/updateNotificationById/${pushNotificationId}`, {});
  }

  addToFavourite(pushNotificationId: any, isFavourite: any): Observable<any> {
    return this._http.put<any>(`${environment.administration}/updateFavourite/${pushNotificationId}/${isFavourite}`, {});
  }

  // Assuming this method fetches the emails
  getUserEmails(): Observable<string[]> {
    return this._http.get<string[]>(`${this.passwordUrl}/GetUserEmails`);
  }

  // getting all subscribtion packages
  getAllSubscriptionPackages(): Observable<any> {
    // TODO: remove paginations
    const paginationSettings = {
      pageNumber: 1,
      pageSize: 100,
      search: ""
    };
    return this._http.post<any>(`${environment.administration}/packages`, paginationSettings);
  }

  getPackageDetails(packageId:any): Observable<any> {
    return this._http.get<any>(`${environment.administration}/packages/package/${packageId}`);
  }

  initiateSenderEmailUpdate() {
    return this._http.put<any>(`${environment.integration}/UpdateSenderEmailStatus`, "");
  }

  getAvaliableLicenses(): Observable<any> {
    return this._http.get<any>(`${environment.administration}/availablelicense`);
  }

  resendUserWelcomeEmail(orgId:any): Observable<any> {
    return this._http.put<any>(`${environment.administration}/resendonboardingemail/${orgId}`, {});
  }
}
